import { useBrand } from '@/hooks/useBrand';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { BrandSymbol } from '@/components/brand/BrandSymbol';
import type { Brand } from '@/lib/brand';
import { cn } from '@/lib/utils';

const brands: { brand: Brand; name: string }[] = [
  { brand: 'prime-conecta', name: 'Prime Conecta' },
  { brand: 'empresarial-prime', name: 'Empresarial Prime' },
];

export function BrandSwitcher() {
  const { brand, setBrand, canChooseBrand, isLoadingBrand } = useBrand();
  if (!canChooseBrand || isLoadingBrand) return null;

  return (
    <div className="flex shrink-0 items-center gap-0.5" role="group" aria-label="Identidade visual do CRM">
      {brands.map(item => (
        <Tooltip key={item.brand}>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              aria-label={`Usar visual ${item.name}`}
              aria-pressed={brand === item.brand}
              onClick={() => setBrand(item.brand)}
              className={cn('h-8 w-8 rounded-none border-b-2 p-1',
                brand === item.brand ? 'border-primary dark:border-brand-header' : 'border-transparent')}
            >
              <BrandSymbol brand={item.brand} />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="bottom">
            <p>{item.name} · identidade visual</p>
            <p className="text-xs">Seus acessos e filtros permanecem os mesmos.</p>
          </TooltipContent>
        </Tooltip>
      ))}
    </div>
  );
}
